import * as React from 'react';

const DeliveryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="12"
    fill="none"
    viewBox="0 0 15 12"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.5 6.5h2m-4-2.667 1.333.667.847-2.541c.175-.525.263-.787.425-.98.143-.172.327-.305.535-.386C3.875.5 4.15.5 4.704.5H9.63c.553 0 .83 0 1.065.093.207.081.391.214.534.385.163.194.25.456.425.98L12.5 4.5l1.333-.667m-4 2.667h2M3.7 4.5h6.933c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v1.8c0 .31 0 .465-.025.594a1.33 1.33 0 0 1-1.048 1.047c-.129.026-.284.026-.593.026h-.334A1.333 1.333 0 0 1 10.5 9.833a.333.333 0 0 0-.333-.333h-6a.333.333 0 0 0-.334.333c0 .737-.597 1.334-1.333 1.334h-.333c-.31 0-.465 0-.594-.026a1.33 1.33 0 0 1-1.047-1.047C.5 9.964.5 9.81.5 9.5V7.7c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.02 4.5 2.58 4.5 3.7 4.5"
    ></path>
  </svg>
);

export default DeliveryIcon;
